import React from 'react';
import {Link} from 'react-router-dom'
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {totalPrice} from "../../utils";
import './style.scss'

const OrderRecivedSec = ({cartList}) => {
    return(
        <section className="cart-recived-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="order-top">
                        <h2>Merci Pour Votre Commande ! <span>Votre commande a été reçue</span></h2>
                        <Link to='/home' className="theme-btn">Retour à l'accueil</Link>
                    </div>
                    <Grid className="cartStatus">
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Grid className="cartTotals">
                                        <h2>Détails de la commande</h2>
                                        <Table>
                                            <TableBody>
                                                {cartList.map(item => (
                                                    <TableRow key={item.id}>
                                                        <TableCell><img src={item.proImg} alt="" /> {item.title} {item.price} XAF x {item.qty}</TableCell>
                                                        <TableCell
                                                            align="right">{item.qty * item.price} XAF</TableCell>
                                                    </TableRow>
                                                ))}
                                                <TableRow className="totalProduct">
                                                    <TableCell>Total Produit</TableCell>
                                                    <TableCell align="right">{cartList.length}</TableCell>
                                                </TableRow>
                                                {/* <TableRow>
                                                    <TableCell>Sub Price</TableCell>
                                                    <TableCell align="right">{totalPrice(cartList)} XAF</TableCell>
                                                </TableRow> */}
                                                <TableRow>
                                                    <TableCell><b>Prix Total</b></TableCell>
                                                    <TableCell
                                                        align="right"><b>{totalPrice(cartList)} XAF</b></TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                </div>
            </div>
        </section>
    )
}

export default OrderRecivedSec;